import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import AjeerUpdate from "./AjeerUpdate/AjeerUpdate";
import AjeerAppliedList from "./AjeerAppliedList/AjeerAppliedList";
import AjeerRenewal from "./AjeerRenewal/AjeerRenewal";
import { useLocation } from "react-router-dom";

export default function Ajeer() {
  const location = useLocation();

  //screen Title Show fun
  const dispatch = useDispatch();
  const title = [{ label: "AJEER", link: "/dashboard/Ajeer" }];
  useEffect(() => {
    dispatch(setBreadCrumb(title));
    if (location.state == null) {
    } else {
      setIndex(1);
    }
  }, []);

  //tab index
  const [index, setIndex] = useState(0);
  const handleIndex = (itemNumer) => {
    setIndex(itemNumer);
  };
  return (
    <>
      <div className={`ml-5 mr-5`}>
        <div className="{`flex flex-row-reverse p-10`}">
          <button
            onClick={() => handleIndex(0)}
            className={`p-2 m-1 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            AJEER UPDATE
          </button>
          <button
            onClick={() => handleIndex(1)}
            className={`p-2 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            AJEER APPLIED LIST
          </button>
          <button
            onClick={() => handleIndex(2)}
            className={`p-2 h-10 text-black uppercase text-xs mr-4 rounded-md  ${index == 2 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            AJEER RENEWAL
          </button>
        </div>
        {index === 0 ? (
          <AjeerUpdate setIndex={handleIndex} />
        ) : index === 1 ? (
          <AjeerAppliedList />
        ) : index === 2 ? (
          <AjeerRenewal />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
